import { z } from "zod";

import { bridgeSecretAddress } from "./bridge";
import { zPublicId } from "./zod-format";

/** A Vault login whose password stays in the customer's Key Vault; Quovy stores only this reference. */
export const KEY_VAULT_LOGIN_KIND = "key-vault-login";

export const zKeyVaultLoginReference = z
  .object({
    bridge: zPublicId("bridge"),
    vault: z.string().trim().min(3).max(24),
    secret: z.string().trim().min(1).max(127),
    username: z
      .string()
      .trim()
      .min(1)
      .max(256)
      // The desk sign-in refuses control characters, so a name that has one could never sign in.
      .regex(
        /^[^\u0000-\u001f\u007f]+$/,
        "A Windows user name cannot contain line breaks or control characters.",
      ),
  })
  .transform((value, ctx) => {
    const address = bridgeSecretAddress(value.vault, value.secret);
    if (!address) {
      ctx.addIssue({
        code: "custom",
        message:
          "This is not a Key Vault secret name. Use the vault's name (3 to 24 letters, digits and hyphens) and the secret's name (letters, digits and hyphens).",
        path: ["secret"],
      });
      return z.NEVER;
    }
    return { ...value, vault: address.vault, secret: address.secret };
  });
export type KeyVaultLoginReference = z.output<typeof zKeyVaultLoginReference>;
